import logEvent from './logEvent'
import type { LoggingEvent } from './logEvent'

import type { FileDownload } from "./_types";

/**
 *
 * @param props This object contains
 */

const fileDownload = ({ name, extension, classes, domain, id, text, url, resource_type, type }: FileDownload) => {
  // UA
  // Handled as a legacy event at the moment

  // Tag Manager
  let layerUpdate: LoggingEvent = { event: "file_download" };

  if (name) layerUpdate.file_name = name;
  if (extension) layerUpdate.file_extension = extension;
  // if (classes) layerUpdate.file_classes = classes;
  // if (domain) layerUpdate.file_domain = domain;
  // if (id) layerUpdate.file_id = id;
  if (text) layerUpdate.file_text = text;
  if (url) layerUpdate.file_url = url;
  if (id) layerUpdate.result_id = id
  if (type) layerUpdate.type = type
  if (resource_type) layerUpdate.resource_type = resource_type
  logEvent(layerUpdate)
};

export default fileDownload;
